<template>
  <div id="mainNav" class="topNav">
    <div class="navs">
      <div class="navLeft">
        <img src="@/common/images/nav/nav_logo.png" alt />
      </div>
      <div class="navRight">
        <div class="r_b" v-if="navList && navList.length">
          <el-menu mode="horizontal" class="navMenu" menu-trigger="hover">
            <template v-for="navItem in navList">
              <!-- 只有一个二级菜单时 不使用submenu -->
              <el-menu-item
                class="menuItem rowMenuItem"
                v-if="!navItem.class.length || navItem.class.length == 1"
                :key="navItem.id"
              >
                <router-link :to="navItem.path || navItem.class[0].path">{{ navItem.name || navItem.class[0].name }}</router-link>
              </el-menu-item>
              <el-submenu
                v-else
                :show-timeout="0"
                :hide-timeout="0"
                class="navSubMenu"
                :index="navItem.name"
                :key="navItem.name"
              >
                <template slot="title">
                  <router-link class="menuItem onlyChild" v-if="navItem.class.length == 1" :to="navItem.class[0].path">{{ navItem.class[0].name }}</router-link>
                  <template v-else>{{ navItem.name }}</template>
                </template>
                <template v-for="navChild in navItem.class">
                  <el-menu-item class="menuItem" :key="navItem.id + '_' + navChild.id">
                    <router-link :to="navChild.path">{{ navChild.name }}</router-link>
                  </el-menu-item>
                </template>
              </el-submenu>
            </template>
          </el-menu>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNavList } from "@/api/topNav.js";
import {mapState} from 'vuex'

export default {
  id: "topNav",
  data() {
    return {
    };
  },

  computed: {
    ...mapState(["navList"]),
  },
};
</script>
<style scoped>
.topNav {
  width: 100%;
  height: 100px;
  background: #fff;
}
.navs {
  padding: 0 20px;
  box-sizing: border-box;
  width: var(--content-width);
  min-width: var(--content-min-width);
  height: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  position: relative;
}

.navLeft {
  display: flex;
  align-items: center;
}
.navLeft img{
  width: 294px;
  height: 42px;
}

.navRight {
  height: 100%;
  name-align: left;
  display: flex;
  align-items: center;
  font-size: 18px;
}
.r_b {
  width: 100%;
  padding-top: 31px;
  padding-bottom: 20px;
  height: 100%;
  box-sizing: border-box;
}
.navMenu {
  height: 100%;
}
.el-menu--horizontal {
  border-bottom: none !important;
}

/* 取消选中时的高亮效果 */
.el-menu--horizontal .el-menu-item.is-active,
.el-menu--horizontal .el-submenu .el-submenu__title.is-active {
  border-bottom: none !important;
  color: transparent;
}
.el-menu--horizontal > .el-menu-item {
  height: 49px;
  line-height: 49px;
}
.el-menu--horizontal > .el-submenu >>> .el-submenu__title {
  height: 49px;
  line-height: 49px;
  border-bottom: none !important;
}

.el-submenu >>> .el-submenu__icon-arrow {
  display: none;
}

.menuItem {
  color: #333 !important;
  font-size: 18px;
  border-bottom: none;
  vertical-align: middle;
}
.menuItem a {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #333 !important;
  font-size: 18px;
}
.el-menu--horizontal >>> .el-submenu .el-submenu__title {
  color: #333;
  font-size: 18px;
}
.rowMenuItem {
  padding: 12px 10px;
  /* margin: 0 20px; */
}
.el-menu--horizontal > .el-submenu.is-opened >>> .el-submenu__title,
.el-menu--horizontal > .el-submenu.is-opened >>> .onlyChild,
.el-menu--horizontal > .el-submenu >>> .el-submenu__title:hover,
.el-menu--horizontal > .el-submenu >>> .el-submenu__title:hover .onlyChild,
.rowMenuItem:hover {
  background-color: #398fff !important;
  color: #fff !important;
}
.rowMenuItem:hover a {
  color: #fff !important;
}

/* 二级导航 */
.el-menu--horizontal .el-menu .menuItem {
  height: 50px !important;
}
.el-menu--horizontal .el-menu .menuItem:hover {
  background-color: rgba(57, 143, 255, 0.1) !important;
}
.el-menu--horizontal .el-menu .menuItem:hover a {
  color: #398fff !important;
}
.el-menu--horizontal .el-menu .menuItem:first-of-type {
  margin-top: 7px;
}
.el-menu--horizontal .el-menu .menuItem:last-child {
  margin-bottom: 7px;
}
</style>



// WEBPACK FOOTER //
// src/components/topNav.vue